import React from 'react';

import { InfoCircleIcon } from '@vlabs/icons';
import InfoRow from '@vlabs/shared/components/info-row/InfoRow';
import { Divider } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import st from './LocationInfo.module.sass';

export function LocationInfo({ ...original }) {
  const { t } = useTranslation();
  const { area, city, district, geo_position, house_number, street } = original?.location ?? {};

  let locationInfo = (
    <div className={st.Flex}>
      <InfoCircleIcon className="StaticIcon" />
      <div>{t('events:no_location_data')}</div>
    </div>
  );

  if (Object.values(original?.location).some((value) => !!value)) {
    locationInfo = (
      <>
        <InfoRow title={t('geoposition.city')} value={city} />
        <InfoRow title={t('geoposition.area')} value={area} />
        <InfoRow title={t('geoposition.district')} value={district} />
        <InfoRow title={t('geoposition.street')} value={street} />
        <InfoRow title={t('geoposition.house_number')} value={house_number} />
        <InfoRow title={t('geoposition.latitude')} value={geo_position?.latitude} />
        <InfoRow title={t('geoposition.longitude')} value={geo_position?.longitude} />
      </>
    );
  }

  return (
    <>
      <h6>{t('location')}</h6>
      <Divider small />
      {locationInfo}
    </>
  );
}

LocationInfo.propTypes = {
  original: PropTypes.objectOf(PropTypes.any),
};

LocationInfo.defaultProps = {
  original: undefined,
};
